import Decimal from "decimal.js";

export class OMath {
  static sum(...args) {
    return args
      .reduce((t, i) => t.add(new Decimal(i || 0)), new Decimal(0))
      .toNumber();
  }

  static sub(...args) {
    if (!args.length) return 0;

    const [first, ...rest] = args;

    return rest
      .reduce((t, i) => t.sub(new Decimal(i || 0)), new Decimal(first))
      .toNumber();
  }

  static times(...args) {
    return args
      .reduce((t, i) => t.mul(new Decimal(i || 0)), new Decimal(1))
      .toNumber();
  }

  static div(a, b) {
    return new Decimal(a || 0).div(new Decimal(b || 1)).toNumber();
  }
}
